import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'mallLimits',
  namespaced: true,
  state: {
    mallLimits: {},
  },
  mutations: {
    setMallLimits(state, mallLimits) {
      state.mallLimits = mallLimits
    },
  },
  actions: {
    async getTwoFactorAuthCode({}, { uuid }) {
      const { data } = await defaultApi.getTwoFactorAuthCode({ uuid })
      return data
    },
    async confirmTwoFactorAuthCode({}, { mallLimit, otp }) {
      const { data } = await defaultApi.postTwoFactorAuth(mallLimit, otp)
      // data.is2faRequired = false
      // data.succeededTwoFactorAuth = true
      return data
    },
    async getMallLimits({ commit }) {
      const { data } = await defaultApi.getMallLimits()
      commit('setMallLimits', data)
      return data
    },
    async getMallLimitsDetail({}, { uuid }) {
      const { data } = await defaultApi.getMallLimitsDetail({ uuid })
      return data
    },
  },
}
